import axios from "axios";
import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import {baseUrl} from '../Univ.js'
function IpLabResultEntrySaved(props) {
    const {appt_id, ltestid, ip_id} = useParams();
    const [selectedDateTime, setSelectedDateTime] = useState(new Date());
    const [labData, setlabData] = useState([]);
    const [labtestData, setLabTestData] = useState([]);
    const [labbillData, setLabBillData] = useState([]);
    const [lres, setLres] = useState();
    const [labv, setLabv] = useState({});
    const [changed, setChanged] = useState(false);
    const [patData, setPat] = useState();
    const [age, setAge] = useState();
    const [gender, setGender] = useState();
    const userGroup = localStorage.getItem("userGroup") || "";
    let userGroups = [];
    try {
        const parsed = JSON.parse(userGroup);
        userGroups = Array.isArray(parsed) ? parsed : [parsed];
    } catch {
        userGroups = userGroup.split(",").map((group) => group.trim());
    }
    const handleChange = (event) => {
        const inputName = event.target.name;
        const inputValue = event.target.value;
        if (inputName === 'patient') {
            setPat(inputValue);
        } else if (inputName === 'age') {
            setAge(inputValue);
        } else if (inputName === 'gender') {
            setGender(inputValue);
        }
    };
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response1 = await axios.get(baseUrl + 'ip-lab-test-view-saved/' + appt_id + '/' + ltestid + '/');
                setLabTestData(response1.data);
                setLres(response1.data[0].results.split(','));
                setLabv(response1.data[0].abnormal_status.split(','));
                const response2 = await axios.get(baseUrl + 'ip-lab-test-view/' + ltestid + '/');
                setLabBillData(response2.data);
                const response3 = await axios.get(baseUrl + 'ip-lab-pay/' + appt_id)
                setlabData(response3.data);
                setPat(response3.data[0].pat.patient);
                setAge(response3.data[0].pat.age);
                setGender(response3.data[0].pat.gender);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, []);
    useEffect(() => {
        const textarea = document.querySelector('textarea.no-comma');
        if (!textarea) {
            return;
        }
        function handleKeyDown(e) {
            if (e.keyCode === 188 || e.keyCode === 222) {
                e.preventDefault();
            }
        }
        function handleChangeInput() {
            textarea.value = textarea.value.replace(/,/g, '');
        }
        textarea.addEventListener('keydown', handleKeyDown);
        textarea.addEventListener('change', handleChangeInput);
        textarea.addEventListener('input', handleChangeInput);
        function handleKeyPress(e) {
            const ignoreKeyCodes = [34, 39];
            if (ignoreKeyCodes.includes(e.which)) {
                e.preventDefault();
                document.querySelector('.error').innerHTML = 'only valid characters are allowed';
                document.querySelector('.error').style.display = 'block';
            } else {
                document.querySelector('.error').style.display = 'none';
            }
        }
        document.addEventListener('keypress', handleKeyPress);
        return () => {
            textarea.removeEventListener('keydown', handleKeyDown);
            textarea.removeEventListener('change', handleChangeInput);
            textarea.removeEventListener('input', handleChangeInput);
            document.removeEventListener('keypress', handleKeyPress);
        };
    }, []);
    const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };
    function handleSubmit(event) {
        event.preventDefault();
        let results = '';

        let billIndex = 0;
        const formData = new FormData();
        if (labtestData.length > 0) {
            billIndex = 0;
        }
           const abnormalValues = [];
        for (let billIndex = 0; billIndex < labbillData.length; billIndex++) {
            const billState = labv[billIndex] || {};
            for (let testIndex = 0; testIndex < labtestData.length; testIndex++) {
                abnormalValues.push(billState[`abValue_${testIndex}`] ? "1" : "0");
            }
        }
        const abValueString = abnormalValues.join(",");
        const sampleDate = document.getElementById("sampleDate").value;
        const patient = document.getElementById("patient").value;
        const gender = document.getElementById("gender").value;
        const age = document.getElementById("age").value;
        const pat_id = document.getElementById("pat_id").value;
        const textareaList = document.querySelectorAll('textarea.no-comma');
        textareaList.forEach(textarea => {
            results += textarea.value + ',';
        });
        results = results.slice(0, -1);
        formData.append('patient', patient);
        formData.append('gender', gender);
        formData.append('age', age);
        formData.append('results', results);
        formData.append('abnormal_status', abValueString);
        formData.append('sample_date', sampleDate);
        formData.append('pat_id', pat_id);
        axios.post(baseUrl + 'update-ip-lab-test/' + labtestData[billIndex].id + '/', formData, {
            headers: {
                'content-type': 'multiple/form-data'
            }
        })
            .then(response => {
                if (response.status == 200 || response.status == 201) {
                    console.log(response.data)
                    Swal.fire({
                        title: 'Edited Successfully',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setTimeout(() => {
                        window.location.href = ('/lab-result-view/');
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to add lab entry. Please try again later.',
                    'error'
                );
            });
    }
    const handleValueChange = (event) => {
        const newResult = event.target.value;
        const newAbv = {[event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value};
        setLres(newResult);
        setLabv(newAbv);
    };
    return (
        <section>
            <form onSubmit={handleSubmit}>
                <div>
                    {labData.map((row, index) =>
                        <div className="table-responsive">
                            <table className="erp-table-modern">
                                <tr style={{backgroundColor: "#1bc5ce", color: "white"}}>
                                    <th colSpan="2" className="patient-header">
                                        <input type="hidden" name="pat_id" id="pat_id" value={row.pat.id}/>
                                        <input type="hidden" name="cons_id" id="cons_id" value={row.cons.id}/>

                                        <div className="patient-info-grid">

                                            <div className="info-item">
                                                <label>Patient Name</label>
                                                <input
                                                    type="text"
                                                    name="patient"
                                                    id="patient"
                                                    value={patData}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                />
                                            </div>

                                            <div className="info-item">
                                                <label>Patient ID</label>
                                                <span>{row.pat.pat_id}</span>
                                            </div>


                                            <div className="info-item">
                                                <label>Gender</label>
                                                <input
                                                    type="text"
                                                    name="gender"
                                                    id="gender"
                                                    value={gender}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                />
                                            </div>

                                            <div className="info-item">
                                                <label>Age</label>
                                                <input
                                                    type="text"
                                                    name="age"
                                                    id="age"
                                                    value={age}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                />
                                            </div>

                                            <div className="info-item">
                                                <label>Sample Date & Time</label>
                                                {labtestData[0].sample_date}
                                                <DatePicker
                                                    name="sampleDate"
                                                    id="sampleDate"
                                                    selected={selectedDateTime}
                                                    onChange={handleDateTimeChange}
                                                    dateFormat="yyyy-MM-dd h:mm aa"
                                                    showTimeSelect
                                                    timeIntervals={15}
                                                    timeCaption="Time"
                                                    className="form-control"
                                                />
                                            </div>
                                            <div className="info-item">
                                                <label>Consultant</label>
                                                <span>Dr. {row.cons.consultant}</span>
                                            </div>

                                        </div>
                                    </th>
                                </tr>

                            </table>
                        </div>
                    )}
                    <div className="table-responsive">
                        <table className="erp-table-modern">
                            <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <th align="left">Sample Type</th>
                                <th align="left">Test</th>
                                <th align="left">Results</th>
                                <th align="left">Abnormal</th>
                                <th align="left">Units</th>
                                <th align="left">Ranges</th>
                                <th align="left">Method</th>
                            </tr>
                            </thead>
                            <tbody>
                            {labbillData.map((lab, billIndex) => (
                                <tr key={billIndex}>
                                    <td style={{border: "1px solid", borderColor: "#2194d9"}}>{lab.sample}</td>
                                    <td style={{border: "1px solid", borderColor: "#2194d9"}}>{lab.test}</td>
                                    {labtestData.map((test, testIndex) => {
                                        const results = test.results.split(',').map(res => res.trim());
                                        const abValue = test.abnormal_status.split(',').map(ab => ab.trim());
                                        return (
                                            <React.Fragment key={testIndex}>
                                                <td style={{border: "1px solid", borderColor: "#2194d9"}}>
                          <textarea
                              className="no-comma"
                              tabIndex="0"
                              name={`result_${testIndex}_${billIndex}`}
                              id={`result_${testIndex}_${billIndex}`}
                              value={lres[billIndex]}
                              onChange={(e) => {
                                  setChanged(true);
                                  setLres({
                                      ...lres,
                                      [billIndex]: e.target.value,
                                  });
                              }}
                              required
                          />
                                                </td>
                                                <td style={{border: "1px solid", borderColor: "#2194d9"}}>
<input
                                            className="form-check-input"
                                            tabIndex="-1"
                                            type="checkbox"
                                            name={`abValue_${testIndex}_${billIndex}`}
                                            id={`abValue_${testIndex}_${billIndex}`}
                                            checked={!!(labv[billIndex] || {})[`abValue_${testIndex}`]}
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                setChanged(true);
                                                setLabv((prevState) => ({
                                                    ...prevState, [billIndex]: {
                                                        ...(prevState[billIndex] || {}),
                                                        [`abValue_${testIndex}`]: checked,
                                                    },
                                                }));
                                            }}
                                        />
                                                </td>
                                            </React.Fragment>
                                        );
                                    })}
                                    <td style={{border: "1px solid", borderColor: "#2194d9"}}>{lab.units}</td>
                                    <td style={{border: "1px solid", borderColor: "#2194d9"}}>{lab.ranges}</td>
                                    <td style={{border: "1px solid", borderColor: "#2194d9"}}>{lab.method}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <button type="submit" className="btn btn-primary mt-4">
                        Submit
                    </button>
                </div>
            </form>
        </section>
    );
}
export default IpLabResultEntrySaved;